import React from "react";
import cs from "classnames";
import { Button } from "../Button/Button";

import "./DeleteButton.scss";

interface Props {
  onClick: () => void;
  tooltip?: string;
  className?: string;
}

export const DeleteButton = (props: Props) => {
  const { onClick, tooltip = "Delete", className } = props;

  return (
    <Button
      color="simple"
      iconOnly
      icon="delete-icon"
      tooltip={tooltip}
      className={cs("DeleteButton Button--icon-plain", className)}
      onClick={onClick}
    />
  );
};
